import { IAIAgentTemplate, IAIAgentTemplateGroup } from '../../../extViewmodels/sdk/models/AI';

export function generateSelectorHash(selectors: Record<string, string>): string {
	// Create a consistent identifier from the selectors object by sorting key-value pairs
	const sortedKeys = Object.keys(selectors || {}).sort();
	const selectorString = sortedKeys.map(key => `${key}:${selectors[key]}`).join('|');

	if (!selectorString) {
		return 'no-selectors';
	}

	return selectorString;
}

export function groupAIAgentTemplatesByHash(templates: IAIAgentTemplate[]): IAIAgentTemplateGroup[] {
	const groups = new Map<string, IAIAgentTemplateGroup>();

	templates.forEach(template => {
		const hash = generateSelectorHash(template.selectors);

		if (!groups.has(hash)) {
			groups.set(hash, {
				hash,
				templates: [],
				selectors: template.selectors || {},
			});
		}

		groups.get(hash)!.templates.push(template);
	});

	return Array.from(groups.values()).sort((a, b) => {
		// Sort by number of templates (descending), then by hash
		if (a.templates.length !== b.templates.length) {
			return b.templates.length - a.templates.length;
		}
		return a.hash.localeCompare(b.hash);
	});
}

export function formatConversationType(type: string): string {
	return type.replace(/([A-Z])/g, ' $1').trim();
}

export function formatDate(dateString: string): string {
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
	});
}

export function isSalesRelatedConversationType(conversationType: string): boolean {
	// Check if the conversation type contains "sales" (case-insensitive)
	return conversationType.toLowerCase().includes('sales');
}

/**
 * Extract assistant name from template name by removing parenthetical suffix
 * e.g., "SiteWideAgent (Insurance)" -> "SiteWideAgent"
 */
export function getAssistantNameFromTemplateName(name: string): string {
	return name.replace(/\s*\(.*\)$/, '').trim();
}
